import { Directive, Input } from '@angular/core';
import { AbstractControl, ValidatorFn, Validator, FormControl, NG_VALIDATORS } from '@angular/forms';

function validateDropDownValue(): ValidatorFn {
  return (c: AbstractControl) => {
    const isValid = c.value == 0;
    if (!isValid) {
      return null;
    } else {
      return {
        SelectValidation: {
          valid: false
        }
      };
    }
  };
}
@Directive({
  selector: '[dropDownValidation][ngModel]',
  providers: [
    { provide: NG_VALIDATORS, useExisting: DropDownListValidationDirective, multi: true }
  ]
})
export class DropDownListValidationDirective implements Validator {
  @Input() dropDownValidation: string;
  validator: ValidatorFn;

  constructor() {
    this.validator = validateDropDownValue();
  }

  validate(c: FormControl) {
    if (this.dropDownValidation == "undefined" || this.dropDownValidation == null || this.dropDownValidation == "false") {
      return null;
    } else {
      return this.validator(c);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/directives/validation/dropdownlist.validation.ts